module.exports = __webpack_public_path__ + "img/picking1.63df24fd.png";